import { render, staticRenderFns } from "./IndustryField.vue?vue&type=template&id=683ce590&"
import script from "./IndustryField.vue?vue&type=script&lang=js&"
export * from "./IndustryField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports